import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { BookOpen, Clock, ShieldCheck, HeartPulse, Map } from 'lucide-react';
export function BundleContents() {
  const items = [{
    icon: <BookOpen className="w-8 h-8 text-terracotta" data-id="element-20" />,
    title: 'Guía Digital Crianza Neuro-Calma',
    desc: 'El paso a paso para dominar tus reacciones y liderar tu hogar con amor.'
  }, {
    icon: <Clock className="w-8 h-8 text-terracotta" data-id="element-21" />,
    title: 'Protocolo de 7 Segundos',
    desc: 'La técnica de emergencia para detener el grito antes de que salga de tu boca.'
  }, {
    icon: <ShieldCheck className="w-8 h-8 text-terracotta" data-id="element-22" />,
    title: 'Plan de Blindaje en Público',
    desc: 'Qué hacer exactamente en Target o Walmart cuando el berrinche ocurre frente a extraños.'
  }, {
    icon: <HeartPulse className="w-8 h-8 text-terracotta" data-id="element-23" />,
    title: 'Checklist de Reparación Post-Grito',
    desc: 'Cómo arreglar la conexión con tu hijo si ya perdiste el control.'
  }, {
    icon: <Map className="w-8 h-8 text-terracotta" data-id="element-24" />,
    title: 'Hoja de Rutas Visuales',
    desc: 'El sistema para que la hora de dormir deje de ser una batalla campal.'
  }];
  return <section className="py-20 px-4 bg-cream-100" data-id="element-25">
      <div className="max-w-4xl mx-auto" data-id="element-26">
        <FadeIn data-id="element-27">
          <h2 className="text-3xl md:text-5xl font-bold text-center mb-16" data-id="element-28">
            Todo lo que recibes hoy
          </h2>
        </FadeIn>

        <div className="space-y-6" data-id="element-29">
          {items.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-30">
              <div className="bg-white p-6 md:p-8 rounded-2xl shadow-sm border border-cream-200 flex flex-col md:flex-row items-start md:items-center gap-6 hover:border-gold-300 transition-colors" data-id="element-31">
                <div className="w-16 h-16 bg-cream-100 rounded-full flex items-center justify-center shrink-0" data-id="element-32">
                  {item.icon}
                </div>
                <div data-id="element-33">
                  <h3 className="text-2xl font-bold mb-2 font-heading text-warmBrown-900" data-id="element-34">
                    {item.title}
                  </h3>
                  <p className="text-lg text-warmBrown-700" data-id="element-35">{item.desc}</p>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}